import { render, staticRenderFns } from "./TwBenchmarkTableBody.vue?vue&type=template&id=1e3c85ea&scoped=true"
import script from "./TwBenchmarkTableBody.vue?vue&type=script&lang=ts"
export * from "./TwBenchmarkTableBody.vue?vue&type=script&lang=ts"
import style0 from "./TwBenchmarkTableBody.vue?vue&type=style&index=0&id=1e3c85ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e3c85ea",
  null
  
)

export default component.exports